import Vue from 'vue';
import dayjs from 'dayjs';
import axios from 'axios';

import DonateFlow from './components/DonateFlow.vue';


let vuePage = document.querySelector('.vjs');
if (vuePage) {

  Vue.config.productionTip = false;

  Vue.prototype.$dayjs = dayjs;
  Vue.prototype.$axios = axios;

  new Vue({
    el: vuePage,
    components: {
      DonateFlow: DonateFlow,
    },
  });
}